<template>
  <div>
    <label class="file-btn">
      Прикрепить файл
      <input
        ref="fileInput"
        type="file"
        multiple
        @change="onFilesChanged"
        :disabled="value.length >= 5"
        class="hidden-input"
      />
    </label>
    <p class="hint-to-upload">
      Максимальное количество файлов: 5<br>
      Максимальный размер файла: 10MB<br>
      Форматы: png, jpg, mp4, mov
    </p>
    <p
      class="max-files-count-hint"
      v-if="value.length >= 5">
      Достигнуто максимальное количество файлов!
    </p>
    <ul>
      <li v-for="(file, index) in value" :key="index">
        {{ file.name }}
        <button type="button" @click="removeFile(index)">×</button>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * @description Максимальное количество прикрепленных файлов
 * @type {int}
 */
const MAX_FILES_COUNT = 5;
export default {
  name: 'InputMultiplyFiles',
  methods: {
    onFilesChanged(e) {
      const currentCount = this.value.length;
      const selectedCount = e.target.files.length;
      if (currentCount + selectedCount <= MAX_FILES_COUNT) {
        const newFiles = [...this.value, ...Array.from(e.target.files)];
        this.$emit('input', newFiles);
      }
    },
    removeFile(index) {
      const updated = this.value.filter((_, i) => i !== index);
      this.$emit('input', updated);
    },
  },
  props: {
    value: { type: Array, default: null },
  },
  emits: ['update:modelValue'],
};
</script>

<style scoped>
.hidden-input {
  display: none;
}

.file-btn {
  width: 100%;
  height: 2.2rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #0489E0;
  background-color: #FFFFFF;
  color: #0489E0;
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;
}

.file-btn:hover {
  background-color: #f0f8ff;
}
.max-files-count-hint {
  color: #0489E0;
}
.hint-to-upload {
  color: #666666;
  padding-bottom: 5px;
}

.file-btn {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 5px;
  font-size: 18px;
  line-height: 25px;
  border: none;
  &::before {
    content: "";
    background-image: url("@/assets/img/paperclip-blue.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 10px 0 0;
    width: 25px;
    height: 25px;
  }
}
</style>
